/**
 * WhatsApp sent DIRECTLY (Meta's WhatsApp Business Cloud API) — a placeholder card only.
 *
 * Today messages go through the Message API gateway (the `message_api` channel). This card holds
 * the place for a direct WhatsApp channel: the fields it will need, all disabled, no backend.
 * When it is built it becomes a third channel key next to `email` and `message_api`.
 */
import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/outline';
import { StatusPill } from '../common/Callout';
import { AACard, AASwitch, aaInputCls, aaLabelCls } from './AlertActionsControls';

const FIELDS: { label: string; placeholder: string; wide?: boolean }[] = [
  { label: 'Phone number ID', placeholder: 'e.g. 109876543210987' },
  { label: 'WhatsApp Business account ID', placeholder: 'e.g. 102345678901234' },
  { label: 'Permanent access token', placeholder: 'EAAG…', wide: true },
  { label: 'Message template', placeholder: 'e.g. trinetra_alert' },
  { label: 'Template language', placeholder: 'e.g. en' },
];

export default function WhatsAppChannelPlaceholder() {
  return (
    <AACard
      icon={ChatBubbleOvalLeftEllipsisIcon}
      title="WhatsApp (direct)"
      subtitle="Send alerts straight through the WhatsApp Business API, without a gateway in between."
      right={(
        <>
          <StatusPill tone="neutral">Coming soon</StatusPill>
          <AASwitch checked={false} disabled label="WhatsApp (direct) is not available yet" onChange={() => {}} />
        </>
      )}
      footer={<p className="text-[12px] text-muted-foreground">Not available yet. Until then, alert messages go out through the <b className="font-medium text-foreground">Message API</b> channel.</p>}
    >
      <fieldset disabled aria-disabled className="grid grid-cols-1 gap-3 opacity-60 sm:grid-cols-2">
        {FIELDS.map((f) => (
          <label key={f.label} className={`block ${f.wide ? 'sm:col-span-2' : ''}`}>
            <span className={aaLabelCls}>{f.label}</span>
            <input className={`${aaInputCls} cursor-not-allowed`} placeholder={f.placeholder} />
          </label>
        ))}
      </fieldset>
    </AACard>
  );
}
